/* unplugin-vue-components disabled */import { render } from "./countrySelectComp.vue?vue&type=template&id=bed0479a"
import script from "./countrySelectComp.vue?vue&type=script&lang=js"
export * from "./countrySelectComp.vue?vue&type=script&lang=js"

import exportComponent from "/var/jenkins_home/workspace/JOINMC-H5-HTML-MASTER/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__